import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

export const ProcedureDefinition = () => (
  <LazyTooltip
    tooltip={gt(
      'A procedure is a step-by-step checklist that describes how to carry out a specific task.'
    )}
  >
    <u>{gt('procedures')}</u>
  </LazyTooltip>
);

export const PolicyDefinition = () => (
  <LazyTooltip
    tooltip={gt(
      'A policy is a plain document that sets out rules, guidelines or principles for decision making in an organisation.'
    )}
  >
    <u>{gt('policies')}</u>
  </LazyTooltip>
);
